module.exports = __webpack_public_path__ + "static/media/1.89b0e751.png";